import React, { useRef, useState, useEffect } from "react";
import parse from "html-react-parser";
import CountUp from "react-countup";
import DataFetcher from "../DataFetcher/DataFetcher";

// 🔁 Reusable hook for visibility detection
const useInView = (options) => {
  const ref = useRef();
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.disconnect(); // Trigger only once
      }
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [ref, options]);

  return [ref, isInView];
};

// 🧩 Component for a single counter item
const CounterItem = ({ counter, index }) => {
  const [ref, isVisible] = useInView({ threshold: 0.4 });
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true); // Ensures consistency between server and client
  }, []);

  return (
    <div
      className="col-md-3 counter col-sm-6 text-center"
      ref={ref}
      data-aos="fade-up"
      data-aos-delay={`${index}00`}
      data-aos-duration={700}
    >
      <h4 className="count white-color font-700 text-center">
        {hasMounted && isVisible ? (
          <CountUp
          end={counter.value}
          duration={2}
          prefix="$"
          separator=","
        />
        ) : (
          0
        )}
      </h4>
      <h3 className="text-left">{counter.name}</h3>
    </div>
  );
};

// 🧱 Main Section Component
const FunFactsArchitecture3 = ({
  title,
  tagline,
  paragraph1,
  paragraph2,
  paragraph3,
  paragraph4,
  children,
}) => {
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}?op=numbers3`;

  return (
    <section className="parallax-bg-18 fixed-bg fact-section text-center" data-stellar-background-ratio="0.2">
      <div className="col-md-2">
        <h4 className="text-uppercase" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}>- -</h4>
      </div>

      <div className="overlay-bg text-center"></div>
      <div className="container">
        <div className="row white-color">
          <div className="col-md-2">
            <h1 className="text-uppercase font-700" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}>
              {title}
            </h1>
            <h4 className="text-uppercase" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}>
              - {tagline} -
            </h4>
          </div>

          <div className="col-md-8">
            {paragraph1}
            <h2 className="text-uppercase" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}><br /><br />{paragraph2}</h2>
            <h3 className="text-uppercase" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}> - {paragraph3} -</h3>
            <div className="mt-15" data-aos={"fade-up"} data-aos-delay={200} data-aos-duration={700}>
              {children ? parse(children) : ""}
            </div>
          </div>
        </div>

        <div className="row mt-30">
          <div className="col-md-8"></div>
          <div className="col-md-12">
            <div className="row">
            <DataFetcher url={API_URL}>
                {(dataCounters) =>
                  dataCounters?.map((counter, i) => (
                   <CounterItem key={i} counter={counter} index={i} />
                  ))
                }
              </DataFetcher>
            </div>
          </div>
        </div>

        <br /><br />
        <h6 className="text-uppercase white" data-aos={"fade-right"} data-aos-delay={100} data-aos-duration={700}>
          {paragraph4}
        </h6>
      </div>
    </section>
  );
};

export default FunFactsArchitecture3;
